<template>
    <v-dialog width="500" max-width="100%" v-model="deleteDialog" scroll-strategy="none">
        <template v-slot:activator="{ props }">
            <v-btn variant="text" color="white" v-bind="props" size="sm"> <v-icon icon="mdi-delete"></v-icon> </v-btn>
        </template>
        <v-card>
            <v-card-text>
                <div class="text-body-1 text-center">
                    Etes-vous sûr de vouloir supprimer l'inscription de <br />
                    <b>{{ nom_coureur }}</b> ?
                </div>
                <div class="d-flex justify-center flex-wrap gap mt-2">
                    <v-btn color="dark-red" variant="text" @click="deleteDialog = false">Non</v-btn>
                    <v-btn color="dark-green" variant="text" @click="$emit('onDelete')">Oui</v-btn>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ['nom_coureur'],
    name: 'ButtonDeleteInscription',
    data() {
        return {
            deleteDialog: false
        }
    },
}
</script>

<style scoped></style>